import { useState } from "react";
import Xicon from "../../assets/x-icon.svg";
import EmailIcon from "../../assets/mail-icon.svg";
import { openLink } from "../../services/openLink.ts";
import FacebookIcon from "../../assets/facebook-icon.svg";
import LinkedInIcon from "../../assets/linkedin-icon.svg";
import LinkDarkIcon from "../../assets/link-dark-icon.svg";
import LinkWhiteIcon from "../../assets/link-white-icon.svg";
import { usePropertyModalStore } from "../../stores/sharePropertyModalStore.ts";

const SharePropertyModal = () => {
	const { listingId, setShowPropertyModal } = usePropertyModalStore();

	const shareUrl = `https://zown.ca/${listingId}`;
	const [isCopied, setIsCopied] = useState(false);

	const copyToClipboard = async () => {
		try {
			if (navigator?.clipboard?.writeText) {
				await navigator.clipboard.writeText(shareUrl);
			} else {
				const input = document.createElement("input");
				input.value = shareUrl;
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
			}

			setIsCopied(true);
			setTimeout(() => setIsCopied(false), 3000);
		} catch (err) {
			console.error("Failed to copy: ", err);
		}
	};

	return (
		<div className="fixed flex inset-0 z-50 items-center justify-center px-2">
			<div
				className="absolute inset-0 bg-white/1 backdrop-blur-xs"
				data-overlay
				onClick={() => setShowPropertyModal(false)}
				onKeyDown={(e) => {
					if (e.key === "Escape") {
						setShowPropertyModal(false);
					}
				}}
			/>
			<div className="relative w-full max-w-2xs rounded-3xl bg-white shadow-2xl">
				<div className="text-black body-lg font-bold py-3.5 text-center border-b border-black/10">
					Share Listing
				</div>
				<button
					type="button"
					onClick={() => setShowPropertyModal(false)}
					className="h-10 w-10 bg-[#EBE8E8] rounded-full absolute top-2 right-2 flex items-center justify-center"
				>
					{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M12.8536 3.14645C13.0488 3.34171 13.0488 3.65829 12.8536 3.85355L3.85355 12.8536C3.65829 13.0488 3.34171 13.0488 3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464L12.1464 3.14645C12.3417 2.95118 12.6583 2.95118 12.8536 3.14645Z"
							fill="#757272"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M3.14645 3.14645C3.34171 2.95118 3.65829 2.95118 3.85355 3.14645L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L3.14645 3.85355C2.95118 3.65829 2.95118 3.34171 3.14645 3.14645Z"
							fill="#757272"
						/>
					</svg>
				</button>
				<div className="grid grid-cols-2 gap-2 p-5 items-center justify-center">
					<button
						type="button"
						onClick={() =>
							openLink(
								`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
							)
						}
						className="flex flex-col text-center gap-4 text-[#74796D] items-center justify-center"
					>
						<img src={FacebookIcon} alt="" />
						Facebook
					</button>
					<button
						type="button"
						onClick={() =>
							openLink(
								`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
							)
						}
						className="flex flex-col text-center gap-4 text-[#74796D] items-center justify-center"
					>
						<img src={Xicon} alt="" />X
					</button>
					<button
						type="button"
						onClick={() =>
							openLink(
								`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent("Check out this property on Zown")}&summary=${encodeURIComponent("See this new property listing and share it with your network.")}&source=Zown`,
							)
						}
						className="flex flex-col text-center gap-4 text-[#74796D] items-center justify-center"
					>
						<img src={LinkedInIcon} alt="" />
						LinkedIn
					</button>
					<button
						type="button"
						onClick={() =>
							openLink(
								`mailto:?subject=Check this property&body=${encodeURIComponent(shareUrl)}`,
							)
						}
						className="flex flex-col text-center gap-4 text-[#74796D] items-center justify-center"
					>
						<img src={EmailIcon} alt="" />
						Email
					</button>
					<button
						type="button"
						disabled={isCopied}
						onClick={copyToClipboard}
						className="col-span-2 font-bold bg-[#F6F6F6] text-[#383D38] disabled:text-white disabled:bg-[#575757] rounded-lg p-3 flex items-center justify-center gap-2"
					>
						<img src={isCopied ? LinkWhiteIcon : LinkDarkIcon} alt="" />
						{isCopied ? "Link Copied" : "Copy Link"}
					</button>
				</div>
			</div>
		</div>
	);
};
export { SharePropertyModal };
